import { render, staticRenderFns } from "./SiskeudesDetailTable.vue?vue&type=template&id=ea2b23ca&lang=pug"
import script from "./SiskeudesDetailTable.vue?vue&type=script&lang=js"
export * from "./SiskeudesDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports